import React from 'react';
import './CustomSelectDropdownContainer.scss';

export const customSelectDropdownContainerId = 'custom-select-dropdown-container';

export default function CustomSelectDropdownContainer() {
	return (
		<div id={customSelectDropdownContainerId}></div>
	);
}
